import { Component } from '@angular/core';
import { PermissionsService } from 'src/app/services/permissions.service';
import { BulevartSettingsSidebar } from 'src/app/utils/enum/sidebar-settings';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-bulevart-settings',
    templateUrl: './bulevart-settings.component.html',
    styleUrls: ['./bulevart-settings.component.scss']
})
export class BulevartSettingsComponent {
    readonly SidebarSettings = BulevartSettingsSidebar;
    selectedComponent!: BulevartSettingsSidebar;
    env = environment;
    filteredComponents: string[] = [];

    constructor(private permissionsService: PermissionsService) {
        this.filterComponents();
    }

    filterComponents() {
        this.filteredComponents = [...this.componentKeys];

        if (!this.permissionsService.hasPermission('auth-module.bulevart-settings.category.list')) {
            this.filteredComponents = this.filteredComponents.filter(item => item !== BulevartSettingsSidebar.CATEGORII)
        }
        if (!this.permissionsService.hasPermission('auth-module.bulevart-settings.subcategory.list')) {
            this.filteredComponents = this.filteredComponents.filter(item => item !== BulevartSettingsSidebar.SUBCATEGORII)
        }
        if (!this.permissionsService.hasPermission('auth-module.bulevart-settings.tertiary-category.list')) {
            this.filteredComponents = this.filteredComponents.filter(item => item !== BulevartSettingsSidebar.CATEGORII_TERTIARE)
        }
    }

    componentMapping: Record<BulevartSettingsSidebar, string> = {
        [BulevartSettingsSidebar.CATEGORII]: 'app-categories',
        [BulevartSettingsSidebar.SUBCATEGORII]: 'app-subcategories',
        [BulevartSettingsSidebar.CATEGORII_TERTIARE]: 'app-tertiary-categories',
    };
    componentKeys: string[] = Object.keys(this.componentMapping);

    onChange($event: { value: any }) {
        this.selectedComponent = $event.value;
    }

    selectedSection: any = null;
}
